export const GCAL = {
  UserPoolId: `${process.env.REACT_APP_GCAL_USER_POOL_ID}`,
  ClientId: `${process.env.REACT_APP_GCAL_CLIENT_ID}`,
  Endpoint: `${process.env.REACT_APP_GCAL_ENDPOINT}`,
};
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const ASSETS_CDN_URL = process.env.REACT_APP_ASSETS_CDN_URL;
export const CLOUDFLARE_IMAGE_PREFIX = process.env.REACT_APP_CLOUDFLARE_IMAGE_PREFIX;
